module.exports = __webpack_public_path__ + "static/media/IconoPila.400a3817.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/IconoPila.svg
// module id = 114
// module chunks = 0